import TagManager from "react-gtm-module";

let gtmInitialized = false;

/** Categories that typically cover GTM tags (analytics + marketing). */
const GTM_CONSENT_CATEGORIES = ["targeting", "performance"] as const;

type CookieScriptState = {
  action?: string;
  categories?: string[];
};

type CookieScriptWindow = Window & {
  CookieScript?: {
    instance?: {
      currentState?: () => CookieScriptState;
    };
  };
};

const hasGtmCategoryConsent = (categories: string[] | undefined): boolean => {
  if (!categories?.length) return false;
  return GTM_CONSENT_CATEGORIES.some((category) => categories.includes(category));
};

export const initGoogleTagManager = (gtmId: string) => {
  if (gtmInitialized || !gtmId) return;
  gtmInitialized = true;
  TagManager.initialize({ gtmId });
};

const tryInitFromStoredConsent = (gtmId: string) => {
  const cookieScript = (window as CookieScriptWindow).CookieScript;
  const state = cookieScript?.instance?.currentState?.();
  if (!state || state.action === "reject") return;
  if (hasGtmCategoryConsent(state.categories)) initGoogleTagManager(gtmId);
};

export const scheduleGoogleTagManager = (gtmId: string) => {
  if (typeof window === "undefined" || !gtmId) return;

  const init = () => initGoogleTagManager(gtmId);

  window.addEventListener("CookieScriptAcceptAll", init);

  window.addEventListener("CookieScriptAccept", (event) => {
    const categories = (event as CustomEvent<{ categories?: string[] }>).detail?.categories;
    if (!categories || hasGtmCategoryConsent(categories)) {
      init();
    }
  });

  // Fires on load when the visitor already accepted these categories earlier.
  window.addEventListener("CookieScriptCategory-targeting", init);
  window.addEventListener("CookieScriptCategory-performance", init);

  window.addEventListener("CookieScriptLoaded", () => tryInitFromStoredConsent(gtmId));

  // Cookie-Script may already be ready if this runs after the banner script loaded.
  tryInitFromStoredConsent(gtmId);
};
